(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-sheet-data]').textContent);
    const select = root.querySelector('[data-thickness]');
    const requestedId = new URL(location.href).searchParams.get('variant');
    const initial = data.variants.find(v => String(v.id) === requestedId) || data.variants.find(v => v.sku);
    if (initial) select.value = String(initial.id);
    const quantity = root.querySelector('[data-field="qty"]');
    const button = root.querySelector('[data-add]');
    function update(changed) {
      const v = data.variants.find(v => String(v.id) === select.value);
      if (!v) return;
      const standard = Boolean(v.sku);
      root.querySelector('[data-variant-id]').value = v.id;
      root.querySelector('[data-price]').textContent = standard ? `${v.price} ${data.strings.unit}` : data.strings.quote;
      root.querySelector('[data-sku]').textContent = standard ? `SKU: ${v.sku}` : '';
      root.querySelector('[data-status]').textContent = !standard ? data.strings.custom : v.available ? data.strings.available : data.strings.unavailable;
      button.hidden = !(standard && v.available);
      button.disabled = button.hidden;
      quantity.min = v.min; quantity.step = v.step;
      if (v.max != null) quantity.max = v.max; else quantity.removeAttribute('max');
      if (changed) quantity.value = v.min;
      if (changed || !new URL(location.href).searchParams.has('variant')) {
        const url = new URL(location.href); url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
      const productUrl = new URL(data.url, location.origin); productUrl.searchParams.set('variant', v.id);
      const lines = [data.title, v.title, standard ? `SKU: ${v.sku}` : data.strings.custom, productUrl.href];
      root.querySelectorAll('[data-field]').forEach(field => {
        if (field.value) lines.push(`${data.strings[field.dataset.field]}: ${field.value}`);
      });
      root.querySelector('[data-enquiry]').href = `mailto:solutions@goindustrial.com?subject=${encodeURIComponent(data.title + ' — ' + v.title)}&body=${encodeURIComponent(lines.join('\n'))}`;
    }
    select.addEventListener('change', () => update(true));
    root.querySelectorAll('[data-field]').forEach(field => field.addEventListener('input', () => update(false)));
    root.querySelector('form').addEventListener('submit', event => {
      const v = data.variants.find(v => String(v.id) === select.value);
      if (!v || !v.sku || !v.available) event.preventDefault();
    });
    update(false);
  }
  document.querySelectorAll('[data-sheet-product]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-sheet-product]').forEach(init));
})();
